import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/pages/stores/change-request-approved.css';
import SelectSearch from '../../common/SelectSearch';
import ReactCalender from '../../common/Datepicker';
import Card from '../../common/Card';
import Input from '../../common/Input';
import Button from '../../common/Button';
import Modal from '../../common/Modal';
import Label from '../../common/Label';
import Pagination from '../../common/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompetitorStoresByStoreCode, fetchDepartments, setLoader } from '../../../redux/actions/api';
import EditTable from '../../tables/EditTable';
import { getTableChangeRequestApprovedHeadquarter } from '../../tables/table';
import { ChangeRequestControllerService, ConstantsControllerService, PriceSearchRequest } from '../../../services';
import { setToastsError, setToastsSuccess, setToastsWarning } from '../../../redux/actions/common';
import apiErrorHandler from '../../../api/apiErrorHandler';
import { setDeleteConfirm, setIsDeleteContinue } from '../../../redux/actions/modal';
import { useLocation } from 'react-router-dom';
import { clearErrors } from '../../../redux/actions/error';
import MultiSelect from '../../common/MultiSelect';
import { setChangeRequestType } from '../../../redux/actions/storage';
import { getDeviationRates } from '../../../utils/helpers/formula';
import { isPastDate } from '../../../utils/helpers/date';
import { isInvalidJan } from '../../../utils/helpers/validation';

const DEFAULT_STATE = {
    departments: [],
    lines: [],
    classes: [],
    subclasses: [],

    jan: '',
    startDate: '',
    endDate: '',
    selectedDepartment: null,
    selectedLine: null,
    selectedClass: null,
    selectedSubclass: null,
    competitorStoreCode: [],
    competitorStoreCodes: [],
    selectedData: [],

    selectedSource: '',
    selectedStartDate: '',
    selectedEndDate: '',
    authorizerName: '',

    isShowPleaseDeleteSelect: false,
    isSearched: false,
    isDelete: false,
    isLoad: false,

    paginate: new Date(),

    page: 1,
    limit: 30,
    apiResponse: null,
};

const ChangeRequestApprovedHeadquarter = (props) => {
    const { type } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();

    const sort = useSelector((state) => state.sort);

    const constants = useSelector((state) => state.constants);
    const { departments, competitorStores } = constants;

    const modal = useSelector((state) => state.modal);
    const { isDeleteContinue } = modal;

    const [state, setState] = useState(DEFAULT_STATE);

    const {
        lines,
        classes,
        subclasses,

        jan,
        startDate,
        endDate,
        selectedDepartment,
        selectedLine,
        selectedClass,
        selectedSubclass,
        competitorStoreCode,
        competitorStoreCodes,
        selectedData,

        isShowPleaseDeleteSelect,
        isSearched,
        isDelete,
        isLoad,

        paginate,

        page,
        limit,
        apiResponse,
    } = state;

    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        setState(DEFAULT_STATE);
        dispatch(clearErrors());
        dispatch(fetchDepartments());
        dispatch(fetchCompetitorStoresByStoreCode());
        dispatch(setChangeRequestType(type));
    }, [dispatch, location]);

    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        getChangeRequestsApproved(page);
    }, [sort]);

    useEffect(() => {
        if (isDeleteContinue) {
            dispatch(setIsDeleteContinue(false));
            handleSubmitModalDelete();
        }
    }, [isDeleteContinue]);

    // 部門が変更された場合
    useEffect(() => {
        // ライン名、クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            lines: [],
            selectedLine: null,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // 部門が選択されている場合のみ
        if (selectedDepartment) {
            (async () => {
                try {
                    // ライン一覧を取得
                    const response = await ConstantsControllerService.getLines([selectedDepartment.value]);
                    const lines = response.map((item) => ({
                        value: item.lineCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('lines', lines);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedDepartment]);

    // ライン名が変更された場合
    useEffect(() => {
        // クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // ライン名が選択されている場合のみ
        if (selectedLine) {
            (async () => {
                try {
                    // クラス一覧を取得
                    const response = await ConstantsControllerService.geClasses(selectedLine.value);
                    const classes = response.map((item) => ({
                        value: item.classCode,
                        label: item.divisionName,
                        lineCode: item.lineCode,
                    }));
                    handleChangeState('classes', classes);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedLine]);

    // クラス名が変更された場合
    useEffect(() => {
        // サブクラス名をクリア
        // API の呼び出しに時間がかかるため先にクリアしておく
        setState((prevState) => ({
            ...prevState,

            subClasses: [],
            selectedSubclass: null,
        }));

        // クラス名が選択されている場合のみ
        if (selectedClass) {
            (async () => {
                try {
                    // サブクラス一覧を取得
                    const response = await ConstantsControllerService.geSubclasses(selectedClass.lineCode, selectedClass.value);
                    const subclasses = response.map((item) => ({
                        value: item.subclassCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('subclasses', subclasses);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedClass]);

    const table = getTableChangeRequestApprovedHeadquarter(t);

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleChangeMultiState = (field, option = []) => {
        setState((prevState) => ({
            ...prevState,
            [field]: option,
        }));
    };

    const createCompetitorStoreOptions = () => {
        return (
            competitorStores?.map((item) => ({
                value: item.competitorStoreCode,
                label: item.competitorStoreName,
            })) ?? []
        );
    };

    const handleCloseModal = () => {
        setState((prevState) => ({
            ...prevState,
            isShowPleaseDeleteSelect: false,
        }));
    };

    const handleDelete = () => {
        if (selectedData.length === 0) {
            setState((prevState) => ({
                ...prevState,
                isShowPleaseDeleteSelect: true,
            }));
        } else {
            dispatch(setDeleteConfirm(true));
        }
    };

    const handlePageClick = (event) => {
        const pageNumber = event.selected + 1;
        getChangeRequestsApproved(pageNumber);
    };

    const handleClear = () => {
        setState((prevState) => ({
            ...prevState,
            lines: [],
            classes: [],
            subclasses: [],
            jan: '',
            startDate: '',
            endDate: '',
            selectedDepartment: null,
            selectedLine: null,
            selectedClass: null,
            selectedSubclass: null,
            competitorStoreCode: [],
            competitorStoreCodes: [],
        }));
    };

    const handleSetSelectedData = () => {
        if (apiResponse) {
            const displayData = apiResponse.data;
            setState((prevState) => {
                const newData = [
                    ...prevState.selectedData.filter(
                        (item) => !displayData.some((newItem) => newItem.changeRequestId === item.changeRequestId && !newItem.selected),
                    ),
                    ...displayData.filter(
                        (newItem) =>
                            newItem.selected && !prevState.selectedData.some((item) => item.changeRequestId === newItem.changeRequestId),
                    ),
                ];

                return {
                    ...prevState,
                    selectedData: newData,
                };
            });
        }
    };

    const getChangeRequestsApproved = (pageNumber) => {
        // JANに数字以外が含まれていないか確認
        if (isInvalidJan(jan)) {
            dispatch(setToastsError(t('message.error.jan')));
            return;
        }
        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('page', pageNumber);
        const isChanged = () => {
            const values = [jan, startDate, endDate, selectedDepartment, selectedLine, selectedClass, selectedSubclass];
            const arrays = [competitorStoreCode];
            return values.some((value) => value !== '' && value !== null) || arrays.some((value) => value.length !== 0);
        };

        // 検索条件が入力されているか確認
        if (isChanged()) {
            handleChangeState('isSearched', true);
        } else {
            handleChangeState('isSearched', false);
        }

        // 検索
        ChangeRequestControllerService.getChangeRequestsApproved({
            changeRequestType: PriceSearchRequest.changeRequestType.FLYER,
            departmentCode: selectedDepartment ? selectedDepartment.value : null,
            lineCode: selectedLine ? selectedLine.value : null,
            classCode: selectedClass ? selectedClass.value : null,
            subclassCode: selectedSubclass ? selectedSubclass.value : null,
            jan: jan ? jan : null,
            startDate: startDate ? startDate : null,
            endDate: endDate ? endDate : null,
            competitorStoreCodes: competitorStoreCodes.length === 0 ? null : competitorStoreCodes,
            page: pageNumber,
            limit: limit,
            sortField: table.heads.find((head) => head.field === sort.sortField)?.field,
            sortType: table.heads.find((head) => head.field === sort.sortField)?.field ? sort.sortType : null,
        })
            .then(async (response) => {
                const responseData = response.data?.map((item) => ({
                    ...item,
                    selected: selectedData.some((dataItem) => dataItem.changeRequestId === item.changeRequestId),
                }));

                setState((prevState) => ({
                    ...prevState,
                    apiResponse: { ...response, data: responseData },
                }));
                await getPromiseResult(response.data);
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error);
            })
            .finally(() => {
                handleChangeState('paginate', new Date());
                dispatch(setLoader(false));
            });
    };

    const [discounts, setDiscounts] = useState([]);
    const getPromiseResult = async (responseData) => {
        const data = await discountCheck(responseData);
        setDiscounts(data);
    };

    const discountCheck = async (items) => {
        if (!items) {
            return [];
        }
        try {
            const responses = await getDeviationRates(dispatch, items);
            const results = await Promise.all(
                responses.map(async (item) => {
                    // CMP-1604: 原価割れ判断が不十分なため一時的に削除
                    // if (item.requestSellingPrice < item.costPrice) {
                    //     return 'belowCost';
                    // }

                    const deviationRate = item.deviationRate;

                    if (deviationRate >= 30) {
                        return '30%';
                    }

                    if (deviationRate >= 10) {
                        return '10%';
                    }
                    return '';
                }),
            );

            return results;
        } catch (error) {}
    };

    const handleSubmitModalDelete = () => {
        // 期限切れ(終了日<本日)の売価は削除対象から除外する
        const validData = selectedData.filter((item) => !isPastDate(item.endDate));
        const hasExpired = validData.length !== selectedData.length;

        if (validData.length === 0) {
            // 全件期限切れの場合は削除APIを呼ばず、選択(チェックボックス)を解除してトーストのみ表示する
            setState((prevState) => ({
                ...prevState,
                // 表示中ページ以外の選択も解除するためselectedDataもクリアする
                selectedData: [],
                apiResponse: {
                    ...prevState.apiResponse,
                    data: prevState.apiResponse.data.map((item) => ({ ...item, selected: false })),
                },
            }));
            dispatch(setToastsWarning('期限切れの売価以外が削除されました。'));
            return;
        }

        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('isDelete', true);
        const ids = validData.map((item) => item.changeRequestId);
        ChangeRequestControllerService.deleteApprovedChangeRequestForFlyer(ids)
            .then(() => {
                setState((prevState) => ({
                    ...prevState,
                    selectedData: [],
                    apiResponse: null,
                    isLoad: true,
                }));
                if (hasExpired) {
                    dispatch(setToastsWarning('期限切れの売価以外が削除されました。'));
                } else {
                    dispatch(setToastsSuccess('削除が完了しました。'));
                }
            })
            .catch((error) => {
                apiErrorHandler(dispatch, error, t('message.error.delete'));
            })
            .finally(() => {
                handleChangeState('isDelete', false);
                dispatch(setDeleteConfirm(false));
                dispatch(setLoader(false));
            });
    };

    useEffect(() => {
        if (!isDelete && apiResponse === null && isLoad) {
            setState((prevState) => ({
                ...prevState,
                isLoad: false,
            }));
            getChangeRequestsApproved(page);
        }
    }, [isDelete]);

    const setDataTable = (data) => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: {
                ...state.apiResponse,
                data,
            },
        }));
    };

    return (
        <>
            <div className="okc-inner">
                <Card handleSubmit={() => getChangeRequestsApproved(1)} handleClear={handleClear}>
                    <Label type="column" text={t('approved_registration_price.search_form.jan.title')} className="col-lg-2 mb-2 mb-lg-4" />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <Input
                            className="form-control form-control--input"
                            type="text"
                            value={jan}
                            maxLength="16"
                            placeholder={t('approved_registration_price.search_form.jan.placeholder')}
                            autocomplete="off"
                            onChange={(value) => {
                                handleChangeState('jan', value);
                            }}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.division_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={departments}
                            placeholder={t('prohibited_product_list.search_form.division.placeholder')}
                            onChange={(value) => handleChangeState('selectedDepartment', value)}
                            value={selectedDepartment?.value}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('freshness.approved_registration_price.search_form.start_date.title')}
                        className="col-lg-2 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <ReactCalender
                            value={startDate}
                            onChange={(value) => {
                                handleChangeState('startDate', value);
                            }}
                            classNameInputDateTime="text-left"
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.line_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={lines}
                            placeholder={t('price_registration.search_form.line_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedLine', value)}
                            value={selectedLine?.value}
                            disabled={!selectedDepartment || !lines.length}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('freshness.approved_registration_price.search_form.end_date.title')}
                        className="col-lg-2 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <ReactCalender
                            value={endDate}
                            onChange={(value) => {
                                handleChangeState('endDate', value);
                            }}
                            classNameInputDateTime="text-left"
                            minDate={new Date(new Date().setDate(new Date().getDate() - 15))}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.class_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={classes}
                            placeholder={t('price_registration.search_form.class_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedClass', value)}
                            value={selectedClass?.value}
                            disabled={!selectedLine || !classes.length}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.competitor_chain.title')}
                        className="col-lg-2 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <MultiSelect
                            placeholder={t('price_registration.search_form.competitive_chain.placeholder')}
                            onChange={(option, codes) => {
                                handleChangeMultiState('competitorStoreCode', option);
                                handleChangeMultiState('competitorStoreCodes', codes);
                            }}
                            options={createCompetitorStoreOptions(competitorStores, competitorStoreCode)}
                            value={competitorStoreCode}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('approved_registration_price.search_form.subclass_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={subclasses}
                            placeholder={t('price_registration.search_form.subclass_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedSubclass', value)}
                            value={selectedSubclass?.value}
                            disabled={!selectedClass || !subclasses.length}
                        />
                    </div>
                </Card>
                <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                <div className="tab-pane show active">
                    <EditTable
                        isHeightTr
                        confirmStatus="CONFIRMED"
                        isSearched={!isSearched}
                        heads={table.heads}
                        body={table.body}
                        dataTable={apiResponse?.data}
                        setDataTable={setDataTable}
                        pagination={paginate}
                        setSelectedData={handleSetSelectedData}
                        discounts={discounts}
                    />
                    <div className="okc-delete d-flex justify-content-between mb-5">
                        <div className="d-flex okc-pagination-bottom">
                            <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                        </div>
                        <div className="okc-pagination-bottom-btn">
                            <Button className="btn btn--primary ml-3" onClick={handleDelete}>
                                <span className="btn-text">削除</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                type="please_select_checkbox"
                isShow={isShowPleaseDeleteSelect}
                onClose={handleCloseModal}
                isShowIconClose="true"
                title="選択した商品のデータを削除します。"
                btnList={[
                    {
                        name: t('button.OK'),
                        className: 'btn--primary',
                        onClick: () => handleCloseModal(),
                        disabled: false,
                    },
                ]}
            >
                <p className="text-center">削除するデータを選択してください。</p>
            </Modal>
        </>
    );
};

export default ChangeRequestApprovedHeadquarter;
